/*eslint-env jquery*/
import React, { Component, useState } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { unitsService } from '../../_services/units.service'
import UserSelectByUnitType from '../Shared/UserSelectByUnitType'
import unitTypes from '../../_constants/unitTypes'
import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import config from '../../config'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'
import { Tabs, Tab } from 'react-bootstrap'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

export class DataTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      activeTab: 'material',
      model: { name: '', userIds: '' }
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({ modalHeading: 'ثبت واحد جدید', modal: true, model: { name: '', userIds: '' } });
  }

  handleModalEdit = (e) => {
    console.log(e);
    
    let userIds = e.users.map(el => (el.id));
    e["userIds"] = userIds
    let _model = e
    this.setState({ modal: true, model: _model, modalHeading: 'ویرایش واحد "' + _model.name + '"' });
  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ modal: false });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    unitsService.getAll(this.props.unitType)
      .then((res) => {
        console.log(res.data)
        this.setState({ data: res.data, loading: false, isSubmitting: false, modal: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };


  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (_model) => {
    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    unitsService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف واحد', 'واحد با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  handleSubmit = (values) => {
    this.setState({ loading: true });
    // console.log(JSON.stringify(values));
    values["unitType"] = this.props.unitType;

    if (values.id) {

      unitsService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش واحد', 'واحد "' + values.name + '" با موفقیت ویرایش شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    } else {
      console.log(JSON.stringify(values));
      unitsService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت واحد جدید', 'واحد "' + res.data.name + '" با موفقیت ثبت شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    }
  }

  render() {

    const ValidationSchema = Yup.object().shape({
      name: Yup.string().trim().required('نام واحد'),
      userIds: Yup.string().trim().required('مدیر مسئول واحد'),
    });
    const { model, loading } = this.state;
    return (
      <div>

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={this.state.data}
            filterable
            loading={loading}
            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: "نام واحد",
                accessor: "name",
                id: "name",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["name"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                filterable: false,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "نام مدیر مسئول واحد",
                accessor: "user.fullName",
                id: "fullName",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["user.fullName"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                filterable: false,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                Cell: (row) => (
                  row.original.users ?
                    row.original.users.map(user => (
                      <span className="label" key={'user-' + user.id}>{user.fullName}</span>
                    )) : ''
                )
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                // filterable: false,
                Filter: ({ filter, onChange }) =>
                  <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn" >
                    <span>
                      <FaPlus size="16px" />
                      افزودن واحد جدید
                    </span>
                  </a>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalEdit(row.original)} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>

                    <a onClick={() => this.handleDelete(row.original)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />

        </div>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullWidth={true}
          maxWidth="sm"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.handleModalHide()} className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }}></span>
          </DialogTitle>
          <DialogContent dividers={true}
            style={{ minHeight: 225 }}
          >

            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                } = props;
                return (

                  <div className="row" style={{ position: "relative" }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>

                        <div className="row">
                          <div className="form-inline">

                            <div className="col-md-12 col-sm-12">
                              <label>نام واحد</label>
                              <Field type="text"
                                autoFocus
                                name="name"
                                className={
                                  getIn(errors, "name") &&
                                    getIn(touched, "name")
                                    ? "text-input has-error rtl"
                                    : "text-input required rtl"
                                }
                              />
                              <ErrorMessage component={ErrorPopUp} name="name" />
                            </div>

                            <div className="clearfix form-row"></div>

                            <div className="col-md-12 col-sm-12">
                              <label>مدیر مسئول واحد</label>
                              <UserSelectByUnitType
                                multiple={true}
                                selection={true}
                                clearable={true}
                                userType={unitTypes.filter(el => el.value === this.props.unitType)[0].userType}
                                defaultValue={values.userIds}
                                onChange={val => {
                                  console.log(val);

                                  setFieldValue("userIds", val)
                                }}
                              // className={getIn(touched, "userIds") ? getIn(errors, "userIds") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
                              />
                              <ErrorMessage component={ErrorPopUp} name="userIds" type="select" />
                            </div>

                            <div className="clearfix form-row"></div>

                            <div className="col-md-12">
                              <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                                {isSubmitting ?
                                  <AiOutlineLoading className="mdi-spin" size="22px" />
                                  :
                                  <AiOutlineSave size="22px" />
                                }ذخیره</button>
                            </div>
                            <div className="clearfix form-row"></div>

                          </div>
                        </div>


                      </form>
                    </div>
                  </div>

                );
              }}
            </Formik>

          </DialogContent>
        </Dialog >

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف واحد [" + this.state.model.name + "] مطمئن هستید؟"}
        >
        </MySweetAlert>

      </div >
    );
  }
}


const Units = props => {
  const [activeTab, setActiveTab] = useState('unit-' + unitTypes[0].value)

  return (

    <Tabs transition={false}
      id="controlled-tab-example"
      className="units-tabs"
      activeKey={activeTab}
      onSelect={activeTab => setActiveTab(activeTab)}
    >
      {unitTypes.map((item, index) => (
        <Tab eventKey={'unit-' + item.value} key={'unit-' + item.value} title={item.label}>
          {activeTab === ('unit-' + item.value) ?
            <DataTable unitType={item.value} />
            : ''}
        </Tab>
      ))}

    </Tabs>
  )
}
export default Units;